/* eslint-disable @typescript-eslint/no-explicit-any */
import { useParams } from 'react-router-dom';

import { AppRoute, RoutesType } from '../config';

import { FirstParameter, OmitUndefined, PrettifyObject } from 'types';

type DynamicPathRoute = NonNullable<
  {
    [R in AppRoute]: RoutesType[R] extends { isDynamic: true } ? R : null;
  }[AppRoute]
>;

type RouteParams<R extends DynamicPathRoute> = PrettifyObject<
  OmitUndefined<FirstParameter<RoutesType[R]['getPath']>>
>;

/**
 *
 * @param targetRoute the route you want the typed params
 * @returns The dynamic values of your route
 */
export function useRouteParams<R extends DynamicPathRoute>(_r: R): RouteParams<R> {
  const params = useParams();

  return params as RouteParams<R>;
}
